import { useState } from 'react';

import { useAuthStore } from '../auth/store.js';

/**
 * Вход. Логин и пароль, одинаково для всех.
 *
 * Списка сотрудников здесь нет намеренно: раньше на этом экране были плитки
 * с ФИО всего штата, и они отдавались сервером без всякой проверки — то есть
 * были видны любому, кто открыл адрес.
 */
export function LoginScreen(): JSX.Element {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const status = useAuthStore((state) => state.status);
  const busy = useAuthStore((state) => state.busy);
  const error = useAuthStore((state) => state.error);
  const signIn = useAuthStore((state) => state.login);

  const ready = login.trim().length >= 2 && password.length >= 8;

  const submit = (event: React.FormEvent): void => {
    event.preventDefault();
    if (!ready || busy) return;
    void signIn(login, password);
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <form onSubmit={submit} className="w-full max-w-sm">
        <h1 className="mb-2 text-xl font-semibold">Управление производством</h1>
        <p className="mb-6 text-base text-dim">Введите свои логин и пароль</p>

        {status === 'token-expired' && (
          <p className="mb-4 rounded-xl bg-card shadow-card p-4 text-base text-amber-700">
            Срок сессии истёк. Несданные отчёты сохранены и уйдут после входа.
          </p>
        )}
        {error && <p className="mb-4 rounded-xl bg-rose-50 text-rose-800 ring-1 ring-rose-200 p-4 text-base">{error}</p>}

        <div className="flex flex-col gap-3">
          <input
            value={login}
            onChange={(event) => setLogin(event.target.value)}
            placeholder="Логин"
            autoCapitalize="none"
            autoCorrect="off"
            autoComplete="username"
            className="rounded-xl bg-card shadow-card px-5 py-4 text-lg"
          />
          <input
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Пароль"
            type="password"
            autoComplete="current-password"
            className="rounded-xl bg-card shadow-card px-5 py-4 text-lg"
          />
        </div>

        <button
          type="submit"
          disabled={!ready || busy}
          className="mt-6 w-full rounded-xl bg-emerald-600 px-5 py-5 text-lg font-semibold text-white active:bg-emerald-700 disabled:opacity-50"
        >
          {busy ? 'Вхожу…' : 'Войти'}
        </button>

        <p className="mt-6 text-base text-faint">
          Логин и пароль выдаёт администратор. Первый вход на новом устройстве —
          при связи: без сети войдёт только тот, кто на нём уже работал.
        </p>
      </form>
    </div>
  );
}
